import { HeadingSection, HFlow, InfoLabel, Text, VFlow } from 'bold-ui'
import { booleanToSimNaoTitleCase } from 'components/form'
import theme from 'config/theme'
import { css } from 'emotion'
import { InformacoesSocioEconomicas } from 'graphql/types.generated'
import React from 'react'
import { isObjectDeepEmpty } from 'util/object'

interface CidadaoFciInformacoesSocioeconomicasSectionProps {
  informacoesSocioeconomicas: InformacoesSocioEconomicas
}

export const CidadaoFciInformacoesSocioeconomicasSection = (
  props: CidadaoFciInformacoesSocioeconomicasSectionProps
) => {
  const { informacoesSocioeconomicas } = props

  const { id, __typename, ...rest } = informacoesSocioeconomicas ?? {}
  const isInformacoesSocioeconomicasVazio = isObjectDeepEmpty(rest)

  if (isInformacoesSocioeconomicasVazio)
    return (
      <HeadingSection level={2} title='Informações socioeconômicas'>
        <Text fontStyle='italic'>Sem informações registradas</Text>
      </HeadingSection>
    )

  return (
    <HeadingSection level={2} title='Informações socioeconômicas'>
      <VFlow vSpacing={0}>
        <div className={styles.box}>
          <Text fontWeight='bold' fontSize={1}>
            TRIA
          </Text>
        </div>
        <HFlow style={styles.container} hSpacing={2}>
          <InfoLabel title='Nos últimos três meses, os alimentos acabaram antes que tivesse dinheiro para comprar mais comida'>
            {booleanToSimNaoTitleCase(informacoesSocioeconomicas.statusAlimentosAcabaramAntesTerDinheiroComprarMais)}
          </InfoLabel>
          <InfoLabel title='Nos últimos três meses, comeu apenas alguns alimentos que ainda tinha, porque o dinheiro acabou'>
            {booleanToSimNaoTitleCase(informacoesSocioeconomicas.statusComeuAlgunsAlimentosQueTinhaDinheiroAcabou)}
          </InfoLabel>
        </HFlow>
      </VFlow>
    </HeadingSection>
  )
}

const styles = {
  container: css`
    border: 1px solid ${theme.pallete.gray.c90};
    padding: 1.5rem;
    margin-right: 20rem;
  `,
  box: css`
    background-color: ${theme.pallete.gray.c90};
    padding: 0.8rem;
    margin-right: 20rem;
  `,
}
